import {
  pageState,
  pageErrorState,
  pecPlusConfigState,
  resultsLoadingState,
  listSendingState,
  listSendingInitialState,
  listScheduledState,
  listScheduledIntialState,
  listWaitingState,
  listWaitingInitialState,
  itemLoadingSelector,
  itemScheduleDetailsSelector
} from '../state/page'

import {
  modalStopSendingState,
  modalStopCampaignState,
  modalDeleteSendingState,
  modalSendingSegmentationState,
  modalScheduleSendingState,
  modalFasciaDiNonDisturboState
} from '../state/modals'

import {
  criticalErrorState,
  reloadErrorsState,
  reloadErrorsIncrementState
} from '../state/errors'

import {
  fetchRunningSending,
  fetchReadySending,
  fetchStandBySending,
  fetchPecPlusConfigs,
  stopSending,
  recoverSending,
  exchangeSendingsOrder,
  scheduleNow,
  retryCheckQueue,
  cancelCheckQueue,
  deleteSending,
  getSendingSegmentation,
  simulateSending,
  setSendingImmediate,
  setSendingScheduled,
  getNoDisturbConfig,
  removeNoDisturbConfig,
  setNoDisturbConfig,
  updateNoDisturbConfig,
  getSmartPlanningSuggestedDate
} from '../actions/actions'

import { logAppError, logAppInfo } from 'Helpers/logger'

import getIntl from 'Helpers/intl'

import { pendoTrack } from 'Helpers/pendoTracking'

import {
  toastShow,
  TOAST_VARIANT_SUCCESS,
  TOAST_VARIANT_ERROR
} from 'mailup-web-components'
import {
  fromUTCtoZoneFormatted,
  STORE_KEY_ACCOUNT,
  STORE_KEY_FEATURES,
  STORE_KEY_LIST,
  storeGet
} from 'mailup-react-helpers'
import { getTimeObj } from 'Helpers/dates'

export const fetchInitialResultsCallback = ({ set }) => async () => {
  set(resultsLoadingState, { fetchingResults: true })

  try {
    const [sending, scheduled, waiting] = await Promise.all([
      fetchRunningSending(),
      fetchReadySending(),
      fetchStandBySending()
    ])

    set(listSendingState, sending)
    set(listScheduledState, scheduled)
    set(listWaitingState, waiting)
  } catch (error) {
    console.error('### fetchInitialResultsCallback error', error)
    logAppError({ appError: error })
    set(pageErrorState, {
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    })
  }

  set(resultsLoadingState, { fetchingResults: false })
}

export const reloadResultsCallback = ({ set, reset }) => async () => {
  try {
    const [sending, scheduled, standBy] = await Promise.all([
      fetchRunningSending(),
      fetchReadySending(),
      fetchStandBySending()
    ])

    set(listSendingState, sending)
    set(listScheduledState, scheduled)
    set(listWaitingState, standBy)

    reset(reloadErrorsState)
  } catch (error) {
    //  console.error('### error', error)
    logAppError({ appError: error })
    set(reloadErrorsIncrementState, Date.now())
  }
}

export const fetchSendingCallback = ({ set, reset }) => async () => {
  set(listSendingState, {
    ...listSendingInitialState,
    fetchingResults: true
  })

  try {
    const results = await fetchRunningSending()

    set(listSendingState, {
      ...results,
      fetchingResults: false
    })
  } catch (error) {
    logAppError({ appError: error })
    set(listSendingState, prev => ({
      ...prev,
      error: true,
      fetchingResults: false
    }))
    set(criticalErrorState, Date.now())
  }
}

export const fetchScheduledCallback = ({ set, reset }) => async () => {
  set(listScheduledState, {
    ...listScheduledIntialState,
    fetchingResults: true
  })

  try {
    const results = await fetchReadySending()

    set(listScheduledState, {
      ...results,
      fetchingResults: false
    })
  } catch (error) {
    logAppError({ appError: error })
    set(listScheduledState, prev => ({
      ...prev,
      error: true,
      fetchingResults: false
    }))
    set(criticalErrorState, Date.now())
  }
}

export const fetchWaitingCallback = ({ set, reset }) => async () => {
  set(listWaitingState, {
    ...listWaitingInitialState,
    fetchingResults: true
  })

  try {
    const results = await fetchStandBySending()

    set(listWaitingState, {
      ...results,
      fetchingResults: false
    })
  } catch (error) {
    logAppError({ appError: error })
    set(listWaitingState, prev => ({
      ...prev,
      error: true,
      fetchingResults: false
    }))
    set(criticalErrorState, Date.now())
  }
}

export const fetchPecPlusConfigCallback = ({ set }) => async () => {
  set(pageState, prev => ({
    ...prev,
    fetchingResults: true
  }))

  try {
    const configs = await fetchPecPlusConfigs()
    set(pecPlusConfigState, configs)
  } catch (error) {
    logAppError({ appError: error })
    console.error('### fetchPecPlusConfigCallback error', error)
    set(pageErrorState, {
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    })
  } finally {
    set(pageState, prev => ({
      ...prev,
      fetchingResults: false
    }))
  }
}

/* menu actions */

const makeStopSendingCallback = mode => ({
  set,
  snapshot
}) => async idSending => {
  const running = await snapshot.getPromise(listSendingState)
  const scheduled = await snapshot.getPromise(listScheduledState)

  const item = []
    .concat(running.Items, scheduled.Items)
    .find(o => o.idSending === idSending)

  if (item) {
    set(modalStopSendingState, {
      show: true,
      idSending,
      mode
    })
  }
}

export const stopSendingRunningCallback = makeStopSendingCallback('running')
export const stopSendingScheduledCallback = makeStopSendingCallback('scheduled')

export const stopRunningSendingConfirmCallback = ({
  set,
  reset
}) => async idSending => {
  set(itemLoadingSelector(idSending), true)

  try {
    logAppInfo({
      Component: 'CampaignsSendStatus',
      Method: 'stopRunningConfirmCallback',
      Message: 'Inizio stop invio',
      Data: JSON.stringify({ idSending })
    })

    await stopSending(idSending)

    logAppInfo({
      Component: 'CampaignsSendStatus',
      Method: 'stopRunningConfirmCallback',
      Message: 'Fine stop invio',
      Data: JSON.stringify({ idSending })
    })

    toastShow(
      getIntl().formatMessage({ id: 'Load.Schedulation.StoppingSending' }),
      TOAST_VARIANT_SUCCESS,
      'stoppingSending'
    )
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'CampaignsSendStatus',
      Method: 'stopRunningConfirmCallback',
      Message: 'Errore durante lo stop invio',
      Data: JSON.stringify({ idSending })
    })
    set(criticalErrorState, Date.now())
  }
  set(itemLoadingSelector(idSending), false)
  reset(modalStopSendingState)
}

export const stopScheduledSendingConfirmCallback = ({
  set,
  reset
}) => async idSending => {
  set(itemLoadingSelector(idSending), true)

  try {
    logAppInfo({
      Component: 'CampaignsSendStatus',
      Method: 'stopScheduledConfirmCallback',
      Message: 'Inizio stop invio',
      Data: JSON.stringify({ idSending })
    })

    await stopSending(idSending)

    logAppInfo({
      Component: 'CampaignsSendStatus',
      Method: 'stopScheduledConfirmCallback',
      Message: 'Fine stop invio',
      Data: JSON.stringify({ idSending })
    })

    const [scheduled, waiting] = await Promise.all([
      fetchReadySending(),
      fetchStandBySending()
    ])

    set(listScheduledState, scheduled)
    set(listWaitingState, waiting)
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'CampaignsSendStatus',
      Method: 'stopRunningConfirmCallback',
      Message: 'Errore durante lo stop invio',
      Data: JSON.stringify({ idSending })
    })
    set(criticalErrorState, Date.now())
  }
  set(itemLoadingSelector(idSending), false)
  reset(modalStopSendingState)
}

const makeStopCampaignCallback = mode => ({
  set,
  snapshot
}) => async idSending => {
  const running = await snapshot.getPromise(listSendingState)
  const scheduled = await snapshot.getPromise(listScheduledState)

  const item = []
    .concat(running.Items, scheduled.Items)
    .find(o => o.idSending === idSending)

  if (item) {
    set(modalStopCampaignState, {
      show: true,
      idSending,
      idList: item.idList,
      idSource: item.campaignIdSource,
      mode
    })
  }
}

export const stopCampaignRunningCallback = makeStopCampaignCallback('running')
export const stopCampaignScheduledCallback = makeStopCampaignCallback(
  'scheduled'
)

export const stopRunningCampaignConfirmCallback = ({
  set,
  snapshot,
  reset
}) => async idSending => {
  set(itemLoadingSelector(idSending), true)

  try {
    logAppInfo({
      Component: 'CampaignsSendStatus',
      Method: 'stopRunningCampaignConfirmCallback',
      Message: 'Inizio stop invio',
      Data: JSON.stringify({ idSending })
    })

    await stopSending(idSending)

    logAppInfo({
      Component: 'CampaignsSendStatus',
      Method: 'stopRunningCampaignConfirmCallback',
      Message: 'Fine stop invio',
      Data: JSON.stringify({ idSending })
    })

    toastShow(
      getIntl().formatMessage({ id: 'Load.Schedulation.StoppingSending' }),
      TOAST_VARIANT_SUCCESS,
      'stoppingSending'
    )
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'CampaignsSendStatus',
      Method: 'stopRunningCampaignConfirmCallback',
      Message: 'Errore durante lo stop invio',
      Data: JSON.stringify({ idSending })
    })
    set(criticalErrorState, Date.now())
  }
  set(itemLoadingSelector(idSending), false)
  reset(modalStopCampaignState)
}

export const stopScheduledCampaignConfirmCallback = ({
  set,
  snapshot,
  reset
}) => async idSending => {
  set(itemLoadingSelector(idSending), true)

  try {
    logAppInfo({
      Component: 'CampaignsSendStatus',
      Method: 'stopScheduledCampaignConfirmCallback',
      Message: 'Inizio stop invio',
      Data: JSON.stringify({ idSending })
    })

    await stopSending(idSending)

    logAppInfo({
      Component: 'CampaignsSendStatus',
      Method: 'stopScheduledCampaignConfirmCallback',
      Message: 'Fine stop invio',
      Data: JSON.stringify({ idSending })
    })

    const [scheduled, waiting] = await Promise.all([
      fetchReadySending(),
      fetchStandBySending()
    ])

    set(listScheduledState, scheduled)
    set(listWaitingState, waiting)
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'CampaignsSendStatus',
      Method: 'stopScheduledCampaignConfirmCallback',
      Message: 'Errore durante lo stop invio',
      Data: JSON.stringify({ idSending })
    })
    set(criticalErrorState, Date.now())
  }
  set(itemLoadingSelector(idSending), false)
  reset(modalStopCampaignState)
}

export const recoverSendingCallback = ({ set }) => async idSending => {
  set(itemLoadingSelector(idSending), true)
  try {
    logAppInfo({
      Component: 'CampaignsSendStatus',
      Method: 'recoverSendingCallback',
      Message: 'Inizio ripristino invio',
      Data: JSON.stringify({ idSending })
    })

    await recoverSending(idSending)

    logAppInfo({
      Component: 'CampaignsSendStatus',
      Method: 'recoverSendingCallback',
      Message: 'Fine ripristino invio',
      Data: JSON.stringify({ idSending })
    })

    toastShow(
      getIntl().formatMessage({ id: 'Load.Schedulation.RecoveredSending' }),
      TOAST_VARIANT_SUCCESS,
      'recoverSending'
    )

    const [sending, waiting] = await Promise.all([
      fetchRunningSending(),
      fetchStandBySending()
    ])

    set(listSendingState, sending)
    set(listWaitingState, waiting)
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'CampaignsSendStatus',
      Method: 'recoverSendingCallback',
      Message: "Errore durante il ripristino dell'invio",
      Data: JSON.stringify({ idSending })
    })
    set(criticalErrorState, Date.now())
  }

  set(itemLoadingSelector(idSending), false)
}

const MOVE_SENDING_DIRECTION_UP = 'up'
const MOVE_SENDING_DIRECTION_DOWN = 'down'

const makeMoveSendingCallback = direction => ({
  set,
  snapshot
}) => async idSending => {
  const { ImmediateSendings } = await snapshot.getPromise(listScheduledState)

  const index = ImmediateSendings.findIndex(id => id === idSending)
  const swapIdSending =
    direction === MOVE_SENDING_DIRECTION_UP
      ? ImmediateSendings[index - 1]
      : ImmediateSendings[index + 1]

  set(itemLoadingSelector(idSending), true)
  set(itemLoadingSelector(swapIdSending), true)

  try {
    logAppInfo({
      Component: 'CampaignsSendStatus',
      Method: 'moveSendingCallback',
      Message: 'Inizio cambio ordine invii',
      Data: JSON.stringify({ idSending, swapIdSending })
    })

    await exchangeSendingsOrder(idSending, swapIdSending)

    logAppInfo({
      Component: 'CampaignsSendStatus',
      Method: 'moveSendingCallback',
      Message: 'Fine cambio ordine invii',
      Data: JSON.stringify({ idSending, swapIdSending })
    })

    const scheduled = await fetchReadySending()

    set(listScheduledState, scheduled)
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'CampaignsSendStatus',
      Method: 'moveSendingCallback',
      Message: 'Errore durante il cambio ordine invii',
      Data: JSON.stringify({ idSending, swapIdSending })
    })
    set(criticalErrorState, Date.now())
  }

  set(itemLoadingSelector(idSending), false)
  set(itemLoadingSelector(swapIdSending), false)
}

export const moveUpSendingCallback = makeMoveSendingCallback(
  MOVE_SENDING_DIRECTION_UP
)
export const moveDownSendingCallback = makeMoveSendingCallback(
  MOVE_SENDING_DIRECTION_DOWN
)

export const scheduleNowCallback = ({ set }) => async idSending => {
  set(itemLoadingSelector(idSending), true)

  try {
    logAppInfo({
      Component: 'CampaignsSendStatus',
      Method: 'scheduleNowCallback',
      Message: 'Inizio imposta schedulazione immediata invio',
      Data: JSON.stringify({ idSending })
    })

    await scheduleNow(idSending)

    logAppInfo({
      Component: 'CampaignsSendStatus',
      Method: 'scheduleNowCallback',
      Message: 'Fine imposta schedulazione immediata invio',
      Data: JSON.stringify({ idSending })
    })

    const [sending, waiting] = await Promise.all([
      fetchRunningSending(),
      fetchStandBySending()
    ])

    set(listSendingState, sending)
    set(listWaitingState, waiting)
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'CampaignsSendStatus',
      Method: 'scheduleNowCallback',
      Message: 'Errore imposta schedulazione immediata invio',
      Data: JSON.stringify({ idSending })
    })
    set(criticalErrorState, Date.now())
  }

  set(itemLoadingSelector(idSending), false)
}

export const retryCheckQueueCallback = ({
  set,
  snapshot
}) => async idSending => {
  const { Items } = await snapshot.getPromise(listWaitingState)

  const { idAsyncQueue } = Items.find(o => o.idSending === idSending)

  set(itemLoadingSelector(idSending), true)

  try {
    logAppInfo({
      Component: 'CampaignsSendStatus',
      Method: 'retryCheckQueueCallback',
      Message: 'Inizio retry send',
      Data: JSON.stringify({ idSending, idAsyncQueue })
    })

    await retryCheckQueue(idAsyncQueue)

    logAppInfo({
      Component: 'CampaignsSendStatus',
      Method: 'retryCheckQueueCallback',
      Message: 'Fine retry send',
      Data: JSON.stringify({ idSending, idAsyncQueue })
    })

    const waiting = await fetchStandBySending()

    set(listWaitingState, waiting)
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'CampaignsSendStatus',
      Method: 'retryCheckQueueCallback',
      Message: 'Errore in retry send',
      Data: JSON.stringify({ idSending, idAsyncQueue })
    })
    set(criticalErrorState, Date.now())
  }

  set(itemLoadingSelector(idSending), false)
}

export const cancelCheckQueueCallback = ({
  set,
  snapshot
}) => async idSending => {
  const { Items } = await snapshot.getPromise(listWaitingState)

  const { idAsyncQueue } = Items.find(o => o.idSending === idSending)

  set(itemLoadingSelector(idSending), true)

  try {
    logAppInfo({
      Component: 'CampaignsSendStatus',
      Method: 'cancelCheckQueueCallback',
      Message: 'Inizio cancel send',
      Data: JSON.stringify({ idSending, idAsyncQueue })
    })

    await cancelCheckQueue(idAsyncQueue)

    logAppInfo({
      Component: 'CampaignsSendStatus',
      Method: 'cancelCheckQueueCallback',
      Message: 'Fine cancel send',
      Data: JSON.stringify({ idSending, idAsyncQueue })
    })

    const waiting = await fetchStandBySending()

    set(listWaitingState, waiting)
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'CampaignsSendStatus',
      Method: 'cancelCheckQueueCallback',
      Message: 'Errore in cancel send',
      Data: JSON.stringify({ idSending, idAsyncQueue })
    })
    set(criticalErrorState, Date.now())
  }

  set(itemLoadingSelector(idSending), false)
}

export const deleteSendingCallback = ({ set }) => idSending => {
  set(modalDeleteSendingState, {
    show: true,
    idSending
  })
}

export const deleteSendingConfirmCallback = ({
  set,
  reset
}) => async idSending => {
  set(itemLoadingSelector(idSending), true)
  reset(modalDeleteSendingState)

  try {
    logAppInfo({
      Component: 'CampaignsSendStatus',
      Method: 'deleteSendingConfirmCallback',
      Message: 'Inizio elimina coda',
      Data: JSON.stringify({ idSending })
    })

    await deleteSending(idSending)

    logAppInfo({
      Component: 'CampaignsSendStatus',
      Method: 'deleteSendingConfirmCallback',
      Message: 'Fine elimina coda',
      Data: JSON.stringify({ idSending })
    })

    const waiting = await fetchStandBySending()

    set(listWaitingState, waiting)
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'CampaignsSendStatus',
      Method: 'deleteSendingConfirmCallback',
      Message: 'Errore in elimina coda',
      Data: JSON.stringify({ idSending })
    })
    set(criticalErrorState, Date.now())
  }

  //  set(itemLoadingSelector(idSending), false)
}

export const sendingSegmentationCallback = ({ set }) => async idSending => {
  set(modalSendingSegmentationState, prev => ({
    ...prev,
    show: true,
    loading: true
  }))

  try {
    const {
      groups,
      excludedGroups,
      filters,
      idMessage,
      stopped,
      ...rest
    } = await getSendingSegmentation(idSending)

    const section = groups.length
      ? 'groups'
      : excludedGroups.length
      ? 'excludedGroups'
      : filters.length
      ? 'filters'
      : 'undefined'

    set(modalSendingSegmentationState, prev => ({
      ...prev,
      loading: false,
      groups,
      excludedGroups,
      filters,
      section,
      idSending,
      ...rest
    }))

    pendoTrack('Sending - Modal segmentation - impression', {
      IdMessage: idMessage,
      SegemtationApplied: section ? 'True' : 'False',
      IsStopped: stopped ? 'True' : 'False'
    })
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'CampaignsSendStatus',
      Method: 'sendingSegmentationCallback',
      Message: 'Errore in apertura modale di segmentazione',
      Data: JSON.stringify({ idSending })
    })

    set(modalSendingSegmentationState, prev => ({
      ...prev,
      loading: false,
      idSending,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
}

export const sendingSegmentationSimulateCallback = ({
  set,
  snapshot
}) => async () => {
  const {
    idMessage,
    idSending,
    groups,
    excludedGroups,
    filters,
    queued
  } = await snapshot.getPromise(modalSendingSegmentationState)

  set(modalSendingSegmentationState, prev => ({
    ...prev,
    simulationLoading: true
  }))

  try {
    const { ToBeQueued } = await simulateSending(
      idSending,
      groups,
      excludedGroups,
      filters
    )

    const simulationDiff = ToBeQueued - queued

    set(modalSendingSegmentationState, prev => ({
      ...prev,
      simulationLoading: false,
      simulationLoaded: true,
      simulationResult: ToBeQueued,
      simulationDiff
    }))

    pendoTrack('Sending - Modal segmentation - result recipients', {
      IdMessage: idMessage,
      IsTheSame: simulationDiff === 0 ? 'True' : 'False',
      Result: simulationDiff
    })
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'CampaignsSendStatus',
      Method: 'sendingSegmentationSimulateCallback',
      Message: 'Errore in simulazione da modale di segmentazione',
      Data: JSON.stringify({ idSending })
    })

    set(modalSendingSegmentationState, prev => ({
      ...prev,
      simulationLoading: false,
      simulationLoaded: true,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
}

export const sendingScheduleCallback = ({
  set,
  snapshot
}) => async idSending => {
  const { ImmediateRunningSendings } = await snapshot.getPromise(
    listSendingState
  )

  const { Items } = await snapshot.getPromise(listScheduledState)

  const item = Items.find(f => f.idSending === idSending)
  const planningType = item ? item.planningType : undefined
  const { ImmediateSendings } = await snapshot.getPromise(listScheduledState)
  const scheduleDetails = await snapshot.getPromise(
    itemScheduleDetailsSelector(idSending)
  )
  const countImmediate =
    ImmediateSendings.length + ImmediateRunningSendings.length

  try {
    const smartPlanningFeature =
      storeGet(STORE_KEY_FEATURES).indexOf('smartPlanning') >= 0
    const account = storeGet(STORE_KEY_ACCOUNT)
    const showSmartPlanning =
      smartPlanningFeature &&
      account.IdOffer !== 3 &&
      account.IdOffer !== 2 &&
      account.IdOffer !== 6 &&
      !account.IsOfferLight // NON E' UNA STARTER - FREQUENZA - SOLOSMS-LIGHT
    let startDateSmart
    let timeZoneCodeSmart
    let detailDateSmart
    if (showSmartPlanning) {
      const rest = await getSmartPlanningSuggestedDate(idSending)
      timeZoneCodeSmart = storeGet(STORE_KEY_LIST).TimeZoneCode
      startDateSmart = rest.SuggestedDate
      detailDateSmart = rest.Detail
    }

    set(modalScheduleSendingState, prev => ({
      ...prev,
      startDateSmart: startDateSmart,
      timeZoneCodeSmart: timeZoneCodeSmart,
      smartPlanningError:
        detailDateSmart && detailDateSmart.Code === 422
          ? 'NoData'
          : detailDateSmart && detailDateSmart.Code === 404
          ? 'DataError'
          : undefined
    }))
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'CampaignsSendStatus',
      Method: 'sendingScheduleCallback',
      Data: JSON.stringify({ idSending })
    })

    set(modalScheduleSendingState, prev => ({
      ...prev,
      startDateSmart: '',
      timeZoneCodeSmart: '',
      smartPlanningError: 'DataError'
    }))
  }

  set(modalScheduleSendingState, prev => ({
    ...prev,
    ...scheduleDetails,

    countImmediate,
    planningType: planningType,
    show: true
  }))
}

export const sendingScheduleSetScheduleCallback = ({ set, reset }) => async (
  idSending,
  dateStart,
  timeZoneCode,
  planningType
) => {
  if (!idSending) {
    return
  }
  set(modalScheduleSendingState, prev => ({
    ...prev,
    sending: true
  }))
  set(itemLoadingSelector(idSending), true)

  try {
    logAppInfo({
      Component: 'CampaignsSendStatus',
      Method: 'sendingScheduleSetScheduleCallback',
      Message: 'Inizio imposta schedulazione invio',
      Data: JSON.stringify({ idSending, dateStart, timeZoneCode })
    })

    await setSendingScheduled(idSending, dateStart, timeZoneCode, planningType)
    if (planningType === 1) {
      pendoTrack('Smart Scheduling - Email Send Status', {})
    }
    logAppInfo({
      Component: 'CampaignsSendStatus',
      Method: 'sendingScheduleSetScheduleCallback',
      Message: 'Fine imposta schedulazione invio',
      Data: JSON.stringify({ idSending, dateStart, timeZoneCode })
    })

    //  reload
    try {
      const [scheduled, waiting] = await Promise.all([
        fetchReadySending(),
        fetchStandBySending()
      ])

      set(listScheduledState, scheduled)
      set(listWaitingState, waiting)
    } catch (innerError) {
      logAppError({
        appError: innerError,
        Component: 'CampaignsSendStatus',
        Method: 'sendingScheduleSetImmediateCallback',
        Message: 'Errore reload ready standby',
        Data: JSON.stringify({ idSending, dateStart, timeZoneCode })
      })

      set(criticalErrorState, Date.now())
    }

    reset(modalScheduleSendingState)
    set(itemLoadingSelector(idSending), false)
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'CampaignsSendStatus',
      Method: 'sendingScheduleSetScheduleCallback',
      Message: 'Errore imposta schedulazione invio',
      Data: JSON.stringify({ idSending, dateStart, timeZoneCode })
    })

    set(modalScheduleSendingState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger',
      sending: false
    }))
  }
}

export const sendingScheduleSetImmediateCallback = ({
  set,
  reset
}) => async idSending => {
  set(itemLoadingSelector(idSending), true)

  try {
    logAppInfo({
      Component: 'CampaignsSendStatus',
      Method: 'sendingScheduleSetImmediateCallback',
      Message: 'Inizio imposta invio sequenziale',
      Data: JSON.stringify({ idSending })
    })

    await setSendingImmediate(idSending)

    logAppInfo({
      Component: 'CampaignsSendStatus',
      Method: 'sendingScheduleSetImmediateCallback',
      Message: 'Fine imposta invio sequenziale',
      Data: JSON.stringify({ idSending })
    })

    //  reload
    try {
      const [scheduled, waiting] = await Promise.all([
        fetchReadySending(),
        fetchStandBySending()
      ])

      set(listScheduledState, scheduled)
      set(listWaitingState, waiting)

      set(itemLoadingSelector(idSending), false)
    } catch (innerError) {
      logAppError({
        appError: innerError,
        Component: 'CampaignsSendStatus',
        Method: 'sendingScheduleSetImmediateCallback',
        Message: 'Errore reload ready standby',
        Data: JSON.stringify({ idSending })
      })

      set(criticalErrorState, Date.now())
    }

    reset(modalScheduleSendingState)
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'CampaignsSendStatus',
      Method: 'sendingScheduleSetImmediateCallback',
      Message: 'Errore imposta invio sequenziale',
      Data: JSON.stringify({ idSending })
    })

    set(modalScheduleSendingState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
}

export const initFasciaDiNonDisturboCallback = ({
  set,
  reset,
  snapshot
}) => async idSending => {
  try {
    set(modalFasciaDiNonDisturboState, prev => ({
      ...prev,
      enable: false,
      loading: true
    }))

    const resp = await getNoDisturbConfig(idSending)

    set(modalFasciaDiNonDisturboState, prev => ({
      ...prev,
      enable: resp && resp.NoDisturbHours.length > 0,
      isFirstConfiguration: !resp,
      Start: resp ? getTimeObj(resp.NoDisturbHours[0].Start, 'T') : prev.Start,
      End: resp ? getTimeObj(resp.NoDisturbHours[0].End, 'T') : prev.End,
      loading: false
    }))
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'CampaignsSendStatus',
      Method: 'initFasciaDiNonDisturboCallback',
      Message: 'initFasciaDiNonDisturboCallback'
    })

    reset(modalFasciaDiNonDisturboState)
    toastShow(
      getIntl().formatMessage({
        id: 'Load.Alerts.ErrorGeneric'
      }),
      TOAST_VARIANT_ERROR,
      'ErrorGeneric'
    )
  }
  return true
}

export const setFasciaDiNonDisturboCallback = ({
  set,
  reset,
  snapshot
}) => async () => {
  set(pageState, prev => ({
    ...prev,
    loading: true
  }))
  try {
    const {
      Start,
      End,
      enable,
      isFirstConfiguration,
      idSending,
      messaggeSubject,
      idMessage
    } = await snapshot.getPromise(modalFasciaDiNonDisturboState)
    reset(modalFasciaDiNonDisturboState)
    if (!enable && !isFirstConfiguration) {
      await removeNoDisturbConfig(idSending)
      toastShow(
        getIntl().formatMessage(
          {
            id: 'Load.Schedulation.SendStatusDectivationSuccess'
          },
          {
            NAME: messaggeSubject
          }
        ),
        TOAST_VARIANT_SUCCESS,
        'SendStatusDectivationSuccess'
      )
      return true
    } else if (enable) {
      const { TimeZoneCode } = storeGet(STORE_KEY_LIST)

      const value = {
        TimeZone: TimeZoneCode,
        NoDisturbHours: [
          {
            Start:
              '1900-01-01T' +
              (Start.hours < 10 ? '0' + Start.hours : Start.hours) +
              ':' +
              (Start.minutes < 10 ? '0' + Start.minutes : Start.minutes) +
              ':00.000Z',
            End:
              '1900-01-01T' +
              (End.hours < 10 ? '0' + End.hours : End.hours) +
              ':' +
              (End.minutes < 10 ? '0' + End.minutes : End.minutes) +
              ':00.000Z'
          }
        ]
      }
      if (isFirstConfiguration) {
        await setNoDisturbConfig(idSending, value)
      } else {
        await updateNoDisturbConfig(idSending, value)
      }
      pendoTrack('evento send status - attivazione FdND', {
        idMessage: idMessage
      })
      toastShow(
        getIntl().formatMessage(
          {
            id: 'Load.Schedulation.SendStatusActivationSuccess'
          },
          {
            NAME: messaggeSubject
          }
        ),
        TOAST_VARIANT_SUCCESS,
        'SendStatusActivationSuccess'
      )
    }

    set(pageState, prev => ({
      ...prev,
      loading: false
    }))
    return true
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'CampaignsSendStatus',
      Method: 'setFasciaDiNonDisturboCallback',
      Message: 'setFasciaDiNonDisturboCallback'
    })

    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger',
      loading: false
    }))
    reset(modalFasciaDiNonDisturboState)
    toastShow(
      getIntl().formatMessage({
        id: 'Load.Alerts.ErrorGeneric'
      }),
      TOAST_VARIANT_ERROR,
      'ErrorGeneric'
    )
    return false
  }
}
